<template>
  <v-dialog v-model="isOpen" width="600">
    <template #activator="{ props }">
      <v-btn variant="text" v-bind="props">
        Додати декілька
        <v-icon class="ml-1" color="#0F6AC1" icon="mdi-plus"></v-icon>
      </v-btn>
    </template>

    <dialog-template
      hide-action-buttons
      title="Додати користувачів"
      @close="isOpen = false">
      <div>
        <b-input v-model="searchStr" label="Пошук..."></b-input>
        <v-tabs
          v-model="currentTab"
          hide-slider
          style="border-bottom: 1px solid #e0e4e7">
          <v-tab value="all">Всі користувачі</v-tab>
          <v-tab value="selected">Обрані</v-tab>
        </v-tabs>

        <div>
          <v-window v-model="currentTab">
            <v-window-item value="all">
              <entity-item
                v-for="entity in filteredEntityList"
                :key="`${entity.entityTypeId}${entity.entityId}`"
                show-checked
                :entity="entity"></entity-item>
            </v-window-item>
            <v-window-item value="selected">
              <entity-item
                v-for="entity in selectedEntityList"
                :key="`${entity.entityTypeId}${entity.entityId}`"
                show-checked
                :entity="entity"></entity-item>
            </v-window-item>
          </v-window>
        </div>
      </div>
    </dialog-template>
  </v-dialog>
</template>

<script lang="ts">
import DialogTemplate from '@/dialog/DialogTemplate.vue'
import { computed, ref } from 'vue'
import { useAcknowledgment } from './index'
import EntityItem from './EntityItem.vue'
import { getDirectory } from '@/directory'

export default {
  name: 'Dialog',
  components: { DialogTemplate, EntityItem },
  setup() {
    const { findAssignmentByEntity } = useAcknowledgment()
    const isOpen = ref(false)
    const currentTab = ref<'all' | 'selected'>('all')
    const searchStr = ref<string>('')

    const filteredEntityList = computed(() => {
      return getDirectory('entityList').filter(e => {
        return e.name
          .toLowerCase()
          .includes(searchStr.value.toLowerCase().trim())
      })
    })

    const selectedEntityList = computed(() => {
      return getDirectory('entityList').filter(e => {
        return !!findAssignmentByEntity(e.entityTypeId, e.entityId)
      })
    })

    return {
      isOpen,
      currentTab,
      searchStr,
      filteredEntityList,
      selectedEntityList,
    }
  },
}
</script>

<style scoped lang="scss"></style>
